module.exports = __webpack_public_path__ + "media/financial_aid_information/620x366_Colorv2-57ff970b.png";